export const createESQueryNextPageBase = (base: string) => {
  if (typeof window=== "undefined") return `${base}?page=`;

  const params = new URLSearchParams(document?.location?.search);
  params.delete("page");
  params.set("page", "");

  return `${base}?${params.toString()}`;
};
